import { Component, Input, ViewChild } from '@angular/core';
import {
  ObservationDefinition,
  ObservationDefinitionReference,
} from 'app/mdm/lib/observation-definition/observation-definition';
import { EditableFlexTableComponent } from '@heda/core-hospital-ui';

@Component({
  selector: 'hw-observation-definition-references-table',
  templateUrl: 'observation-definition-references-table.component.html',
})
export class ObservationDefinitionReferencesTableComponent {
  @Input() public editMode: boolean = true;
  @Input() public definition: ObservationDefinition;
  @ViewChild('referencesTable') public referencesTable: EditableFlexTableComponent<ObservationDefinitionReference>;

  public defaultReferenceRow: ObservationDefinitionReference = {};

  public validate(): boolean {
    return this.referencesTable?.validate();
  }
}
